import React, {useState} from 'react';
import {Link} from 'react-router-dom'
import {withRouter} from 'react-router'
import image from '../loading.gif'
import 'materialize-css'
import 'materialize-css/dist/css/materialize.min.css'
import './signup.css'
import firebase from '../firebase'

const SignUpComponent = (props) => {

    const [email,setEmail] = useState('');
    const [password,setPassword] = useState('');
    const [name,setName] = useState('');
    const [conPass,setConPass] = useState('');
    const [isMatching,setIsMatching] = useState(true);
    const [loading, setLoading] = useState(false);
    console.log(email);
    const registeMe = async()=>{
        setLoading(true);
        if(password !== conPass){
            setIsMatching(false);
        }
        else{
            setIsMatching(true);
            try{
                await firebase.register(name,email,password)
                setLoading(false);
                props.history.replace('/dashboard');
            }catch(error){
                setLoading(false);
                alert(error.message);
            }
        }
    }
    return (
        <div id="signBack">
            {loading?<div className="loading"><img alt="loading" src={image}/></div>:null}
            <div id="form">
                <h2>Gotta GO!<span role="img" onSubmit={e=>e.preventDefault() && false} aria-label="RunEmoji">🏃‍♂️</span></h2>
                <h3>Sign Up</h3>
                {isMatching?<p></p>:<p>Passwords Does Not Match</p>}
                <div className="input-field col s12">
                    <input id="email" type="email" className="validate" required autoFocus value={email} onChange={e=>setEmail(e.target.value)}/>
                    <label htmlFor="email">Enter Your Email</label>
                </div>
                <div className="input-field col s12">
                    <input id="name" type="text" className="validate" required value={name} onChange={e=>setName(e.target.value)}/>
                    <label htmlFor="name">Enter Your Name</label>
                </div>
                <div className="input-field col s12">
                    <input id="password" type="password" className="validate" required value={password} onChange={e=>setPassword(e.target.value)}/>
                    <label htmlFor="password">Enter Your Password</label>
                </div>
                
                <div className="input-field col s12">
                    <input id="conPass" type="password" className="validate" required value={conPass} onChange={e=>setConPass(e.target.value)}/>
                    <label htmlFor="conPass">Confirm Your Password</label>
                </div>
                <button className="cusButton" type="submit" onClick={registeMe}>Register Me!</button>
                {/* <button className="cusButton" id="withGoogle">Register With Google!</button> */}
                <p>Already Have An Account?</p>
                <Link to='/Login'>Sign In!</Link>
            </div>
        </div>
    )
    
}

export default withRouter(SignUpComponent);